export default __webpack_public_path__ + "media/Dairy-Yogurt.68b62bd7.png";